





















































































































export default function (Component) {
  Component.options.__source = "src/components/common/money-editor.vue"
}
